module.exports = __webpack_public_path__ + "img/emoji-good.b4a00473.png";